/* eslint-disable no-underscore-dangle */
import React from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { format } from 'date-fns';
import { DashboardItem } from '../../services/types/Dashboard';
import TaskDetail from './TaskDetail';

interface Props {
  firstDay: Date;
  lastDay: Date;
  daysQty: number;
  taskData: DashboardItem;
}

const GanttRow: React.FC<Props> = (props) => {
  const { firstDay, lastDay, daysQty, taskData } = props;
  const { id, isOverdue, startDate, dueDate, operationNumber, title } = taskData;

  let _startDate = new Date(startDate);
  _startDate.setHours(0, 0, 0, 0);
  let _endDate = dueDate ? new Date(dueDate) : null;
  if (_endDate) {
    _endDate.setHours(0, 0, 0, 0);
  }
  const _dueDate = dueDate ? new Date(dueDate) : null;
  if (_dueDate) {
    _dueDate.setHours(0, 0, 0, 0);
  }
  const hasStart = _startDate >= firstDay;
  if (!hasStart) {
    _startDate = firstDay;
  }
  const hasEnd = _endDate != null && _endDate <= lastDay;
  if (!hasEnd) {
    _endDate = lastDay;
  }
  const weightBefore = hasStart
    ? Math.round((_startDate.getTime() - firstDay.getTime()) / (1000 * 60 * 60 * 24))
    : 0;
  const weightPath =
    _endDate && _endDate >= _startDate
      ? Math.round((_endDate.getTime() - _startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1
      : 0;

  const weightAfter = daysQty - weightPath - weightBefore;
  const in3days = new Date();
  in3days.setDate(in3days.getDate() + 3);
  const isOvercome = !isOverdue && _dueDate && _dueDate < in3days;

  return (
    <>
      <div id={`Path_${id.toString()}`} className={`task-container ${isOverdue ? 'overdue' : ''}`}>
        <div className="path-padding" />
        <div className="task-div-path">
          <div style={{ flex: weightBefore }} />
          <div
            className={`path${hasStart ? ' start' : ''}${hasEnd ? ' end' : ''}${
              isOverdue ? ' overdue' : ''
            }${isOvercome ? ' overcome' : ''}`}
            style={{ flex: weightPath }}
          />

          <div style={{ flex: weightAfter }} />
        </div>
        <div
          className={`task-div-info pl-1${isOverdue ? ' overdue' : ''} ${
            isOvercome ? ' overcome' : ''
          }`}
        >
          <div style={{ flex: weightBefore + weightPath }}>
            <b>{operationNumber}</b>-{title.substr(0, 20)}-{isOverdue && <span> Overdue. </span>}
            {isOvercome && <span> To overcome. </span>}
            Due date {_dueDate ? format(_dueDate, 'dd/MM/yyyy') : 'N/A'}
          </div>
          <div style={{ flex: weightAfter }} />
        </div>
      </div>
      <UncontrolledPopover
        placement="bottom"
        target={`Path_${id.toString()}`}
        trigger="legacy"
        className="popover-gantt"
      >
        <PopoverBody>
          <TaskDetail {...taskData} />
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
};

export default GanttRow;
